import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Home, Search, Calculator as CalcIcon } from 'lucide-react';

export default function NotFoundPage() {
  useEffect(() => {
    document.title = 'Page Not Found — PocketCalculator.net';
    return () => { document.title = 'PocketCalculator.net'; };
  }, []);

  return (
    <div className="max-w-2xl mx-auto text-center py-16 sm:py-24" data-testid="not-found-page">
      <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-blue-100 mb-6">
        <Search className="w-10 h-10 text-blue-600" />
      </div>
      <h1 className="text-5xl sm:text-6xl font-black text-slate-900 mb-3">404</h1>
      <p className="text-xl text-slate-700 mb-2">This page went missing.</p>
      <p className="text-slate-500 mb-8">The link you followed may be broken, or the page may have been moved.</p>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-5 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-semibold transition-colors"
          data-testid="notfound-home-btn"
        >
          <Home className="w-4 h-4" /> Back to Home
        </Link>
        <Link
          to="/category/financial"
          className="inline-flex items-center gap-2 px-5 py-2.5 bg-white border border-slate-300 hover:border-blue-400 text-slate-700 rounded-lg font-semibold transition-colors"
          data-testid="notfound-calc-btn"
        >
          <CalcIcon className="w-4 h-4" /> Browse Calculators
        </Link>
      </div>
    </div>
  );
}
